{ "compressionlevel":-1,
 "height":20,
 "infinite":false,
 "layers":[
        {
         "data":[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         "height":20,
         "id":1,
         "locked":true,
         "name":"tiles",
         "opacity":1,
         "type":"tilelayer",
         "visible":false,
         "width":24,
         "x":0,
         "y":0
        },
        {
         "id":2,
         "image":"image.png",
         "locked":true,
         "name":"image",
         "opacity":1,
         "type":"imagelayer",
         "visible":false,
         "x":0,
         "y":0
        },
        {
         "data":[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         "height":20,
         "id":5,
         "locked":true,
         "name":"data:collision",
         "opacity":1,
         "type":"tilelayer",
         "visible":false,
         "width":24,
         "x":0,
         "y":0
        },
        {
         "draworder":"topdown",
         "id":3,
         "name":"data:encounters",
         "objects":[
                {
                 "height":0,
                 "id":55,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        },
                        {
                         "x":0,
                         "y":280
                        },
                        {
                         "x":210,
                         "y":280
                        },
                        {
                         "x":210,
                         "y":0
                        }],
                 "properties":[
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"1"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":910,
                 "y":210
                },
                {
                 "height":0,
                 "id":56,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        },
                        {
                         "x":0,
                         "y":70
                        },
                        {
                         "x":-70,
                         "y":70
                        },
                        {
                         "x":-70,
                         "y":350
                        },
                        {
                         "x":210,
                         "y":350
                        },
                        {
                         "x":210,
                         "y":140
                        },
                        {
                         "x":140,
                         "y":140
                        },
                        {
                         "x":140,
                         "y":70
                        },
                        {
                         "x":70,
                         "y":70
                        },
                        {
                         "x":70,
                         "y":0
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Scratch my Back"
                        },
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"2"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":980,
                 "y":490
                },
                {
                 "height":0,
                 "id":57,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        },
                        {
                         "x":70,
                         "y":0
                        },
                        {
                         "x":70,
                         "y":70
                        },
                        {
                         "x":140,
                         "y":70
                        },
                        {
                         "x":140,
                         "y":210
                        },
                        {
                         "x":70,
                         "y":210
                        },
                        {
                         "x":70,
                         "y":350
                        },
                        {
                         "x":-70,
                         "y":350
                        },
                        {
                         "x":-70,
                         "y":280
                        },
                        {
                         "x":-140,
                         "y":280
                        },
                        {
                         "x":-140,
                         "y":70
                        },
                        {
                         "x":0,
                         "y":70
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Beating Spears into Hooks"
                        },
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"3"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":1050,
                 "y":840
                },
                {
                 "height":0,
                 "id":58,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        },
                        {
                         "x":0,
                         "y":-70
                        },
                        {
                         "x":-70,
                         "y":-70
                        },
                        {
                         "x":-70,
                         "y":-350
                        },
                        {
                         "x":-280,
                         "y":-350
                        },
                        {
                         "x":-280,
                         "y":-70
                        },
                        {
                         "x":-210,
                         "y":-70
                        },
                        {
                         "x":-210,
                         "y":0
                        },
                        {
                         "x":0,
                         "y":0
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Between a Rock"
                        },
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"4"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":910,
                 "y":1050
                },
                {
                 "height":0,
                 "id":59,
                 "name":"",
                 "polygon":[
                        {
                         "x":0,
                         "y":0
                        },
                        {
                         "x":70,
                         "y":0
                        },
                        {
                         "x":70,
                         "y":-70
                        },
                        {
                         "x":140,
                         "y":-70
                        },
                        {
                         "x":140,
                         "y":-350
                        },
                        {
                         "x":-210,
                         "y":-350
                        },
                        {
                         "x":-210,
                         "y":-70
                        },
                        {
                         "x":0,
                         "y":-70
                        }],
                 "properties":[
                        {
                         "name":"name",
                         "type":"string",
                         "value":"Ire, the Destruction"
                        },
                        {
                         "name":"slug",
                         "type":"string",
                         "value":"5"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":0,
                 "x":700,
                 "y":700
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":true,
         "x":0,
         "y":0
        },
        {
         "draworder":"topdown",
         "id":4,
         "locked":true,
         "name":"data:units",
         "objects":[
                {
                 "gid":7,
                 "height":32,
                 "id":25,
                 "name":"",
                 "properties":[
                        {
                         "name":"key",
                         "type":"string",
                         "value":"swordlord"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":980,
                 "y":280
                },
                {
                 "gid":3,
                 "height":32,
                 "id":26,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"hammer"
                        },
                        {
                         "name":"maxhealth",
                         "type":"string",
                         "value":"20"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":910,
                 "y":420
                },
                {
                 "gid":3,
                 "height":32,
                 "id":27,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"hammer"
                        },
                        {
                         "name":"maxhealth",
                         "type":"string",
                         "value":"20"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1050,
                 "y":420
                },
                {
                 "gid":3,
                 "height":32,
                 "id":28,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"sword"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1120,
                 "y":700
                },
                {
                 "gid":7,
                 "height":32,
                 "id":29,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"none"
                        },
                        {
                         "name":"key",
                         "type":"string",
                         "value":"daggercloak"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1120,
                 "y":770
                },
                {
                 "gid":7,
                 "height":32,
                 "id":30,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1120,
                 "y":980
                },
                {
                 "gid":7,
                 "height":32,
                 "id":31,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1050,
                 "y":910
                },
                {
                 "gid":7,
                 "height":32,
                 "id":32,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":840,
                 "y":1050
                },
                {
                 "gid":7,
                 "height":32,
                 "id":33,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":770,
                 "y":1050
                },
                {
                 "gid":7,
                 "height":32,
                 "id":34,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":700,
                 "y":1050
                },
                {
                 "gid":7,
                 "height":32,
                 "id":35,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":770,
                 "y":630
                },
                {
                 "gid":7,
                 "height":32,
                 "id":36,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":700,
                 "y":630
                },
                {
                 "gid":7,
                 "height":32,
                 "id":37,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":700,
                 "y":700
                },
                {
                 "gid":3,
                 "height":32,
                 "id":38,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"hammer"
                        },
                        {
                         "name":"maxhealth",
                         "type":"string",
                         "value":"20"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":980,
                 "y":490
                },
                {
                 "gid":7,
                 "height":32,
                 "id":39,
                 "name":"",
                 "properties":[
                        {
                         "name":"type",
                         "type":"string",
                         "value":"zone"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":980,
                 "y":560
                },
                {
                 "gid":3,
                 "height":32,
                 "id":40,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"dagger"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":980,
                 "y":840
                },
                {
                 "gid":3,
                 "height":32,
                 "id":42,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"sword"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":910,
                 "y":700
                },
                {
                 "gid":3,
                 "height":32,
                 "id":46,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"spear"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1050,
                 "y":1190
                },
                {
                 "gid":7,
                 "height":32,
                 "id":47,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"none"
                        },
                        {
                         "name":"key",
                         "type":"string",
                         "value":"axeknight"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":1050,
                 "y":1120
                },
                {
                 "gid":3,
                 "height":32,
                 "id":48,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"spear"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":910,
                 "y":980
                },
                {
                 "gid":3,
                 "height":32,
                 "id":50,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"spear"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":770,
                 "y":770
                },
                {
                 "gid":3,
                 "height":32,
                 "id":52,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"sword"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":630,
                 "y":980
                },
                {
                 "gid":3,
                 "height":32,
                 "id":53,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"dagger"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":700,
                 "y":840
                },
                {
                 "gid":3,
                 "height":32,
                 "id":61,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"devil"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"devil"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"spear"
                        },
                        {
                         "name":"key",
                         "type":"string",
                         "value":"archdevil"
                        },
                        {
                         "name":"maxhealth",
                         "type":"int",
                         "value":30
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":490,
                 "y":420
                },

                {
                 "gid":3,
                 "height":32,
                 "id":62,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"dagger"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":490,
                 "y":630
                },
                {
                 "gid":3,
                 "height":32,
                 "id":63,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"dagger"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":770,
                 "y":420
                },
                {
                 "gid":3,
                 "height":32,
                 "id":64,
                 "name":"",
                 "properties":[
                        {
                         "name":"affiliation",
                         "type":"string",
                         "value":"bad"
                        },
                        {
                         "name":"bodyKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"faceKey",
                         "type":"string",
                         "value":"imp"
                        },
                        {
                         "name":"jobKey",
                         "type":"string",
                         "value":"dagger"
                        }],
                 "rotation":0,
                 "type":"",
                 "visible":true,
                 "width":32,
                 "x":560,
                 "y":490
                }],
         "opacity":1,
         "type":"objectgroup",
         "visible":false,
         "x":0,
         "y":0
        }],
 "nextlayerid":6,
 "nextobjectid":67,
 "orientation":"orthogonal",
 "renderorder":"right-down",
 "tiledversion":"1.10.2",
 "tileheight":70,
 "tilesets":[
        {
         "firstgid":1,
         "source":"..\/..\/..\/levels\/tileset.json"
        }],
 "tilewidth":70,
 "type":"map",
 "version":"1.10",
 "width":24
}
